import classNames from 'classnames'
import { Icon, Button } from '../../../atoms'
import React from 'react'
import { connect } from 'react-redux'
import { FsCore } from 'types/fs-core'

const iwocaInfo = {
  copy: {
    offers_available: {
      title: "You're eligible for a startup loan with iwoca.",
      body: `<div>Thank you for filling in your details. You can now explore the loan offers and select the one that's suitable for your business. All the information you've given us will transfer to iwoca.<br/>  <br/>if you have any questions about your loan application, please contact iwoca directly on 02037780274.</div>`,
    },
    deferred: {
      title: 'We’ve sent your application to iwoca',
      body: `<div>iwoca will be in touch shortly to discuss the outcome of your application, so keep an eye on your inbox and have your phone to hand.<br/>  <br/>For questions about your account application, please contact iwoca directly on 020 3778 0274.</div>`,
    },
    other: {
      title: 'We’ve sent your application to iwoca',
      body: `<div>iwoca will be in touch shortly to discuss the outcome of your application, so keep an eye on your inbox and have your phone to hand.<br/>  <br/>For questions about your account application, please contact iwoca directly on 020 3778 0274.</div>`,
    },
    decline: {
      title: 'Unfortunately, your business is not eligible for a startup loan.',
      body: `<div>Thank you for filling in your details but we couldn't find a loan that's right for your business.<br/> <br/>To improve your chances of getting a loan, find out what's impacting your business credit score. You can also explore our other products below.</div>`,
    },
    declined: {
      title: 'Unfortunately, your business is not eligible for a startup loan.',
      body: `<div>Thank you for filling in your details but we couldn't find a loan that's right for your business.<br/> <br/>To improve your chances of getting a loan, find out what's impacting your business credit score. You can also explore our other products below.</div>`,
    },
  },
}

const IwocaResults = ({ iwocaResult }) => {
  return (
    <div
      className={classNames('ResultsCard', {
        'ResultsCard--iwocaDecline': iwocaResult.status === 'decline',
      })}
    >
      <div className='ResultsCard__title'>
        {iwocaResult.status === 'offers_available' && (
          <Icon glyph='tick-circle-bg' size={48} desktopSize={64} fill='#924a8b' />
        )}
        <h2>{iwocaInfo.copy[iwocaResult.status]?.title}</h2>
      </div>
      <div className='ResultsCard__details'>
        <div
          className='ResultsCard__details__body--iwoca'
          dangerouslySetInnerHTML={{ __html: iwocaInfo.copy[iwocaResult.status]?.body }}
        />
      </div>
      {iwocaResult.status === 'offers_available' && iwocaResult.link && (
        <div className='ResultsCard__cta'>
          <Button variant='primary' size='md' href={iwocaResult.link} openInNewTab>
            Discover loan offers
          </Button>
        </div>
      )}
    </div>
  )
}

export default connect((state: FsCore.State, props: any) => {
  return {
    ...props,
    iwocaResult: state.components.iwocaResult,
  }
})(IwocaResults)
